<template>
  <div
    style="
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    "
  >
    <div
      style="
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #aaebe9;
        color: #fff;
      "
      @click="openModal"
    >
      <i class="el-icon-folder-checked" />
    </div>

    <el-dialog
      :visible.sync="approveVisible"
      title="下载进度"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      @close="closeModal"
    >
      <div class="current-list">
        <p>
          <span>当前下载队列</span>
          <el-tooltip content="如遇无法下载的状况，可清空下载队列后再尝试">
            <el-button
              type="info"
              size="mini"
              icon="el-icon-delete"
              :disabled="currentList.length === 0"
              round
              @click="clearCurrent"
            />
          </el-tooltip>
        </p>
        <div class="current-list-wrap">
          <yi-scrollbar style="height: 100%">
            <span class="current-list-empyt" v-if="currentList.length === 0">
              无下载进程
            </span>

            <ul class="current-list-team" v-else>
              <li
                class="current-list-item"
                v-for="(item, index) in currentList"
                :key="index"
              >
                <span class="current-list-item-progress">
                  <i
                    :class="
                      item.isExport ? 'el-icon-download' : 'el-icon-loading'
                    "
                    style="
                      margin-right: 5px;
                      padding: 5px;
                      border-radius: 50%;
                      background: #fff;
                    "
                  ></i>
                </span>
                <span class="current-list-item-title">
                  {{ item.isDownloading ? "正在请求" : item.fileName }}
                  {{ item.isExport ? "--导出中" : "" }}
                </span>
              </li>
            </ul>
          </yi-scrollbar>

          <!-- <div style="height: 10px"></div> -->
        </div>
      </div>

      <div class="history-list">
        <p>
          <span>历史下载记录</span>
          <el-tooltip content="全部清空">
            <el-button
              type="info"
              size="mini"
              icon="el-icon-delete"
              :disabled="historyList.length === 0"
              round
              @click="clearHistory"
            />
          </el-tooltip>
        </p>
        <div class="history-list-wrap">
          <yi-scrollbar style="height: 100%">
            <span class="history-list-empyt" v-if="historyList.length === 0">
              无下载记录
            </span>
            <ul class="history-list-team" v-else>
              <li
                class="history-list-item"
                v-for="(item, index) in historyList"
                :key="index"
              >
                <div class="history-list-item-msg">
                  <span class="history-list-item-msg-name">{{
                    item.fileName
                  }}</span>
                  <span class="history-list-item-msg-date">{{
                    item.completionTime
                  }}</span>
                </div>
                <i
                  class="el-icon-delete"
                  style="
                    margin-left: 5px;
                    width: 24px;
                    height: 24px;
                    border-radius: 50%;
                    background-color: #e8f6ff;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                  "
                ></i>
              </li>
            </ul>
          </yi-scrollbar>
        </div>
      </div>
      <!-- <div v-if="isDownloading">
        <el-button
          type="text"
          :icon="isPaused ? 'el-icon-caret-right' : 'el-icon-download'"
          @click="isPaused ? resumeDownload : pauseDownload"
          plain
        ></el-button>
        <el-progress :percentage="Number(progress).toFixed(0)"></el-progress>
      </div>
      <div v-else>
        <p style="text-align: center;">无下载进度</p>
      </div> -->
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      // currentList: this.$store.state.downloadStore.currentList,
      // historyList: [{},{},{},{},{},{}],
      // approveVisible: this.$store.state.downloadStore.downloadModal,
    };
  },

  computed: {
    ...mapState({
      currentList: (state) => state.downloadStore.currentList,
      historyList: (state) => state.downloadStore.historyList,
      approveVisible: (state) => state.downloadStore.downloadModal,
    }),
  },

  methods: {
    openModal() {
      this.$store.commit("SET_DOWNLOAD_MODAL", true);
    },
    closeModal() {
      this.$store.commit("SET_DOWNLOAD_MODAL", false);
    },

    clearCurrent() {
      this.$confirm("确认清空吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store.commit("REMOVE_CURRENT_LIST");
        this.$message.success("清除完成");
      });
    },

    clearHistory() {
      this.$confirm("确认清空吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store.commit("REMOVE_HISTORY_LIST");
        this.$message.success("清除完成");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
ul {
  margin: 0;
  padding: 0;
  li {
    list-style: none;
    margin: 0;
    padding: 0;
  }
}

.current-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  p {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
    padding: 5px;
    text-align: left;
    background: #f3f3f3;
    color: #858585;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .current-list-wrap {
    height: 200px;
    margin-top: 10px;
    border: 2px solid #e0e0e0;
    border-radius: 5px;
    overflow: hidden;

    ::v-deep.el-scrollbar {
      .el-scrollbar__wrap {
        overflow-x: hidden;

        .current-list-empyt {
          height: 100%;
          flex: 1;
          font-size: 14px;
          color: #b1b1b1;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .current-list-team {
          flex: 1;
          margin: 0;
          padding: 10px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          .current-list-item {
            // list-style: none;
            background-color: #d5e6ff;
            margin-bottom: 10px;
            padding: 5px;
            border-radius: 5px;
            display: flex;
            // flex-direction: column;
            align-items: center;

            box-sizing: border-box;
            &:last-child {
              margin-bottom: 0;
            }

            &:hover {
              background-color: #d4d8df;
            }

            .current-list-item-title {
              font-size: 16px;
              color: #322b55;
              // margin-bottom: 10px
            }
            .current-list-item-progress {
              display: flex;
              align-items: center;
              // margin-right: 10px;
            }
          }
        }
      }
    }
  }
}

.history-list {
  width: 100%;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 2px dashed #b3b3b3;
  display: flex;
  flex-direction: column;

  p {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
    padding: 5px;
    text-align: left;
    background: #f3f3f3;
    color: #858585;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .history-list-wrap {
    margin-top: 10px;
    height: 200px;
    border: 2px solid #e0e0e0;
    border-radius: 5px;
    overflow: hidden;

    ::v-deep.el-scrollbar {
      .el-scrollbar__wrap {
        overflow-x: hidden;

        .history-list-empyt {
          height: 100%;
          flex: 1;
          font-size: 14px;
          color: #b1b1b1;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .history-list-team {
          flex: 1;
          margin: 0;
          padding: 10px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;

          .history-list-item {
            margin-bottom: 10px;
            display: flex;
            align-items: center;

            &:last-child {
              margin-bottom: 0;
            }

            &:hover {
              background-color: #bde2fa;
              .history-list-item-msg {
                background: none;
                &-date {
                  color: #fff;
                }
              }
            }
            .history-list-item-msg {
              flex: 1;
              color: #858585;
              background: #e8f6ff;
              font-size: 14px;
              line-height: 14px;
              font-weight: 400;
              padding: 5px;
              border-radius: 5px;
              box-sizing: border-box;
              display: flex;
              justify-content: space-between;

              &-name {
                font-weight: bold;
              }

              &-date {
                font-size: 12px;
                color: #999999;
              }
            }
          }
        }
      }
    }
  }
}
</style>
